import { getShortName } from '@helpers/getShortName';

import { TProps } from './types/TProps';

const structuralClassName = 'flex items-center justify-center flex-shrink-0 overflow-hidden uppercase font-semibold';

export const defaultEntityIconSizeClassName =
  'h-[30px] w-[30px] bg-[var(--color-avatar-bg)] text-sm leading-[130%] text-[var(--color-on-surface)]';

export const EntityIcon = ({
  name,
  src,
  backgroundColor,
  color,
  className,
  sizeClassName = defaultEntityIconSizeClassName,
  onClick,
  shape = 'square',
}: TProps) => {
  const initials = getShortName(name).toLowerCase();
  const shapeClass = shape === 'round' ? 'rounded-full' : 'rounded-[5px]';
  const imgShapeClass = shape === 'round' ? 'rounded-full' : 'rounded-[5px]';

  return (
    <div
      className={[structuralClassName, sizeClassName, shapeClass, className].filter(Boolean).join(' ')}
      style={{ ...(backgroundColor ? { backgroundColor } : {}), ...(color ? { color } : {}) }}
      onClick={onClick}
    >
      {src ? <img className={`h-full w-full object-cover ${imgShapeClass}`} src={src} alt="" /> : initials}
    </div>
  );
};
